






import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME as ConstName } from '../constants';
import { apiProvider } from '../api';

type DataType = {
	ORDER_NO: number;
	Text: string;
	DODAVATEL_ID: number;
	SUPPLIER: string;
	ORDER_TYPE: string;
	WAREHOUSE_ID: number;
	IS_DEALER: boolean;
};

export default BaseSelect.extend({
	name: selectName(ConstName),
	props: {
		labelKey: { type: String, default: 'ORDER_NO' },
		isClearable: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: ConstName,
			valueFieldName: 'ORDER_NO',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				osobniCis: null,
				DodavatelId: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.ORDER_NO,
				DodavatelId: data.DODAVATEL_ID,
				DodavatelIdText: data.SUPPLIER,
				OrderType: data.ORDER_TYPE,
				SkladOzn: data.WAREHOUSE_ID,
				IsDealer: data.IS_DEALER,
			};
		},
	},
});
